import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { fetchOne } from '../../../lib/v31lib';
import { loginAtom } from '../../../lib/auth';

import {
  Avatar,
  Box,
  Grid,
  Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import IconItsme from "../../../images/itsme.svg";
import LaunchIcon from '@mui/icons-material/Launch';

import { AlertCheckInputs } from '../../../components/alerts/CheckInputs';
import { AlertSaved } from '../../../components/alerts/Saved';
import { AlertSomethingWentWrong } from '../../../components/alerts/SomethingWentWrong';

import {
  AnnAm,
  StyledButton,
  StyledDropzone,
  StyledIconButton,
  Typography
} from '../../../components/interface';
import { DetailLine } from '../../../components/interface/Detail/DetailLine';
import { UserDetailBase } from '../../../components/user_detail/Base';

import { EmissionKey } from '../../../models/EmissionKey';

const { DateTime } = require("luxon");

type Props = {
  emissionKey: EmissionKey;
  isHidden: boolean;
  fields: string[];
  refreshKey: () => void;
};

export const EmissionDetailTabsDetailGift: FunctionComponent<Props> = ({emissionKey, isHidden, fields, refreshKey}) => {
  // const navigate = useNavigate();
  const theme = useTheme();
  // const params = useParams();

  const [login, setLogin] = useAtom(loginAtom);

  const [item, setItem] = useState<File>();

  const [errorSnackOpen, setErrorSnackOpen] = useState<boolean>(false);
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [userSavedSnackOpen, setUserSavedSnackOpen] = useState<boolean>(false);
  const [regenBlankSnackOpen, setRegenBlankSnackOpen] = useState<boolean>(false);









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<any>(
        "/nl/v3/objects/custom_action",
        pars.formData,
        login
      );
    },
    onSuccess: (data, variables, context) => {
      refreshKey();
    },
  });







  
  return (
    <Box hidden={isHidden} sx={{paddingTop: 2}}>
      <Grid container spacing="8">
        <Grid item xs={12} md={4} sx={{alignContent: 'baseline'}}>
          <UserDetailBase
            sx={{
              backgroundColor: 'white'
            }}
            title="Quick Info"
            wide
          >
            <DetailLine name="Receiver Name" value={emissionKey.extra_data?.gift_data?.first_name} />
            <DetailLine name="Buyer email" value={emissionKey.extra_data?.gift_data?.email} />
            <DetailLine no_divider name="Redeemed" bool={!!emissionKey.extra_data?.gift_data?.redeemed} />
          </UserDetailBase>

          <UserDetailBase
            sx={{
              backgroundColor: theme.palette.profile_blox?.identity,
              marginTop: 1
            }}
            title="Order details"
            wide
          >
            <DetailLine name="Amount" value={(emissionKey.proposed_amount || 0).toString()} />
            <DetailLine name="Amount EUR" value={`${parseInt((emissionKey.proposed_value || 0).toString(), 10).toString()} EUR`} />
            <DetailLine no_divider copyable name="ASN" value={emissionKey.modded_asn_key} />
          </UserDetailBase>

          {!!emissionKey?.get_gift_card && <UserDetailBase
            sx={{
              backgroundColor: theme.palette.profile_blox?.security,
              marginTop: 1,
            }}
            wide
            title="Gift card"
            adornment={!!emissionKey && !!emissionKey.get_gift_card && <>
              <StyledIconButton
                path={emissionKey.get_gift_card}
                newTab
                sx={{position: 'absolute', top: 0.5, right: 0.5, width: 24, height: 24}} 
              ><LaunchIcon /></StyledIconButton>
            </>}
          >
            <Grid item xs={12}>
              {!!emissionKey.gift_card_blob_content_type && emissionKey.gift_card_blob_content_type.indexOf("image") > -1 && <img style={{maxWidth: '100%'}} src={emissionKey.get_gift_card} />}
              {!!emissionKey.gift_card_blob_content_type && emissionKey.gift_card_blob_content_type.indexOf("pdf") > -1 && <iframe style={{width: '100%', height: '300px'}} src={emissionKey.get_gift_card} />}
            </Grid>
            <Grid item xs={12}>
              {!!emissionKey?.gift_card_filename && <Typography sx={{fontSize: '0.75rem'}}>Current: {emissionKey?.gift_card_filename} ({(parseInt(emissionKey?.gift_card_byte_size || '0', 10) / (1000*1000)).toFixed(2)}mb)</Typography>}
            </Grid>
          </UserDetailBase>}
        </Grid>
        
        <Grid item xs={12} md={4} sx={{alignContent: 'baseline'}}>
          <UserDetailBase
            sx={{
              backgroundColor: theme.palette.profile_blox?.identity
            }}
            title="Identity"
            wide
            adornment={!!emissionKey && !!emissionKey.gifter_itsme_sub ? <Avatar src={IconItsme} sx={{position: 'absolute', top: 0.5, right: 0.5, width: 24, height: 24}} /> : <></>}
          >
            <DetailLine name="First name" value={!!emissionKey ? emissionKey.gifter_first_name : ''} />
            <DetailLine name="Last name" value={!!emissionKey ? emissionKey.gifter_last_name : ''} />
            <DetailLine name="Birthdate" date={!!emissionKey ? emissionKey.gifter_birth_date : ''} />
            <DetailLine no_divider copyable name="Vennoot Number" value={!!emissionKey ? emissionKey.gifter_vennoot_number : ''} />
          </UserDetailBase>
          <UserDetailBase
            sx={{
              backgroundColor: theme.palette.profile_blox?.account,
              marginTop: 1
            }}
            title="Account"
            wide
          >
            <DetailLine name="Language" value={!!emissionKey ? emissionKey.gifter_locale : ''} />
          </UserDetailBase>
          <UserDetailBase
            sx={{
              backgroundColor: theme.palette.profile_blox?.contact,
              marginTop: 1
            }}
            title="Contact"
            wide
          >
            <Grid item container xs={12} sx={{alignContent: 'baseline'}} rowSpacing="4">
              <DetailLine name="Gender" gender_icons value={!!emissionKey ? emissionKey.gifter_gender : ''} />
              <DetailLine copyable name="E-mail" value={!!emissionKey ? emissionKey.gifter_email : ''} />
              <DetailLine name="Phone" value={!!emissionKey ? emissionKey.gifter_phone : ''} />
              <DetailLine name="Mobile" value={!!emissionKey ? emissionKey.gifter_mobile : ''} />
              <DetailLine no_divider name="Address" value={!!emissionKey ? [emissionKey.gifter_street, emissionKey.gifter_number].join(" ") : ''} />
              <DetailLine no_divider={!(!!emissionKey?.cor_gifter_street && !!emissionKey?.gifter_cor_zip)} name="" value={!!emissionKey ? [emissionKey.gifter_zip, emissionKey.gifter_city].join(" ") : ''} />
              {!!emissionKey?.cor_gifter_street && !!emissionKey?.gifter_cor_zip && <DetailLine no_divider name="COR Address" value={!!emissionKey ? [emissionKey.gifter_cor_street_2].join(" ") : ''} />}
              {!!emissionKey?.cor_gifter_street && !!emissionKey?.gifter_cor_zip && <DetailLine no_divider name="" value={!!emissionKey ? [emissionKey.gifter_cor_street, emissionKey.gifter_cor_number].join(" ") : ''} />}
              {!!emissionKey?.cor_gifter_street && !!emissionKey?.gifter_cor_zip && <DetailLine no_divider name="" value={!!emissionKey ? [emissionKey.gifter_cor_zip, emissionKey.gifter_cor_city].join(" ") : ''} />}
            </Grid>
          </UserDetailBase>
        </Grid>

        <Grid item container xs={12} md={4} sx={{alignContent: 'baseline', flexBasis: "calc(33.33% + 8px) !important"}} spacing="8">
          {!emissionKey.check_borderel && <Grid item xs={12}>
            <Typography variant="h3" sx={{textAlign: 'center', borderBottom: '1px solid transparent', borderColor: theme.palette.primary.main}}>Actions</Typography>
          </Grid>}
          <Grid item xs={6}>
            <StyledButton
              label="Regenerate blank"
              id='regen_blank'
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'emission_key',
                    class_action: 'custom_api_regen_gift_card',
                    handler_id: login?.id,
                    id: emissionKey?.id
                  }
                });
              }}
              sx={{width: '100%'}}
            />
          </Grid>
          <Grid item xs={6}>
            <StyledButton
              label="Re-open code"
              id='reopen_code'
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'emission_key',
                    class_action: 'custom_api_reopen_gift_card',
                    handler_id: login?.id,
                    id: emissionKey?.id
                  }
                });
              }}
              sx={{width: '100%'}}
            />
          </Grid>

        </Grid>
      </Grid>

      {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
      {!!errorSnackOpen && <AlertCheckInputs open={errorSnackOpen} setOpen={(b) => {setErrorSnackOpen(b);}} />}
      {!!userSavedSnackOpen && <AlertSaved open={userSavedSnackOpen} setOpen={(b) => {setUserSavedSnackOpen(b);}} />}

      {!!regenBlankSnackOpen && <Snackbar
        open={regenBlankSnackOpen}
        onClose={() => {setRegenBlankSnackOpen(false);}}
        autoHideDuration={2000}
      >
        <MuiAlert elevation={6} variant="filled" severity="success">
          Unsigned document was regenerated!
        </MuiAlert>
      </Snackbar>}
    </Box>
  );
}
